
<mat-accordion>
  @for (data of accordionData; track $index){
  <mat-expansion-panel (opened)="accordionOpenedEmitter.emit({index: $index,rowData: data})">
    <mat-expansion-panel-header>
      <mat-panel-title>
        {{data.title}}
      </mat-panel-title>
    </mat-expansion-panel-header>
    <ng-template #accordionContent></ng-template>
  </mat-expansion-panel>
  }
</mat-accordion>
